import AccessorySelectorComponent from "./AccessorySelectorComponent.vue";

new Vue({
    el: '#accessory-selector',
    components: {AccessorySelectorComponent}
});
